import { RouteStatus } from '@/api/types';

export function isCompletedOrClosed(status: RouteStatus | undefined) {
  if (status === RouteStatus.Completed || status === RouteStatus.Closed) {
    return true;
  } else {
    return false;
  }
}
